import type { Course as BackendCourse } from "../../../types/university";
import universityCourseCardHero from "../../../assets/branding/tessera-university-course-card-hero.png";

function courseSlugValue(course: BackendCourse): string {
  if (typeof course.slug === "string") return course.slug;
  return course.slug?.current ?? "";
}

function isMonkModeCourse(course: BackendCourse): boolean {
  const title = course.title.trim().toLowerCase();
  const slug = courseSlugValue(course).trim().toLowerCase();

  return (
    title.includes("monk mode") ||
    slug.includes("monk-mode") ||
    slug.includes("monk_mode") ||
    slug === "monkmode"
  );
}

/** Local card art overrides for courses without a backend thumbnail. */
export function resolveUniversityCourseThumbnail(course: BackendCourse): string | undefined {
  if (isMonkModeCourse(course)) {
    return universityCourseCardHero;
  }

  return course.thumbnail;
}
